import { ActionTypesFactory } from "../../common/redux/actions/ActionTypesFactory";

const agreementActionTypes = ActionTypesFactory.readActionTypes(
  "AGREEMENT"
);

export default agreementActionTypes;
